import { Component } from '@verndale/core';
import debounce from 'lodash/debounce';
import { sendValuesToZaiusAndBoxever } from '../helpers/ZaiusBoxeverEvents';
import validate from 'validate.js';
import { waitForElm } from '../helpers';

class Module extends Component {
  setupDefaults() {
    this.dom = {
      formInputs: [...this.el.querySelectorAll('.generic-form__input')],
      form: this.el.querySelector('form'),
      submit: this.el.querySelector('[type=submit]'),
      clickable: this.el.querySelector('.form__submit-wrapper-clickable'),
      submitWrapper: this.el.querySelector('.form__submit-wrapper'),
      spinner: this.el.querySelector('.form__spinner')
    };

    this.isMobile = window.matchMedia('(max-width: 677px)').matches;

    waitForElm('.footer-v2 .fxt-captcha-enterprise').then(elm => {
      if (this.isMobile) {
        elm.closest('div').style.display = 'none';
      }
    });

    if (this.dom.form) {
      this.dom.form.classList.add('active');
      this.dom.submit.disabled = true;

      if (this.dom.submitWrapper) {
        this.dom.submitWrapper.classList.add('form__submit-wrapper--disabled');
      }
      this.checkValue();

      const observer = new window.MutationObserver(mutations => {
        mutations.forEach(({ attributeName }) => {
          if (attributeName === 'data-captcha') {
            this.handleFormChange();
          }
        });
      });
      observer.observe(this.dom.form, { attributes: true });

      this.handleFormChange();
    }
  }

  addListeners() {
    this.dom.formInputs.forEach(element => {
      element.addEventListener('focus', ::this.handleFocus);
      element.addEventListener('blur', ::this.handleBlur);
      element.addEventListener(
        'blur, input',
        debounce(::this.handleFormChange, 100)
      );
      element.addEventListener('paste', debounce(::this.handleFormChange, 300));
    });
    if (this.dom.form) {
      this.dom.form.addEventListener(
        'change',
        debounce(::this.handleFormChange, 100)
      );
      this.dom.form.addEventListener(
        'input',
        debounce(::this.handleFormChange, 100)
      );

      if (this.dom.clickable)
        this.dom.clickable.addEventListener('click', ::this.handleFormClick);
      this.dom.form.addEventListener('submit', ::this.handleSubmit);
      if (this.dom.submit)
        this.dom.submit.addEventListener('click', ::this.showSpinner);
    }

    if (this.dom.form.classList.contains('footer-form')) {
      this.dom.submit.disabled = false;
      this.dom.submitWrapper.classList.remove('form__submit-wrapper--disabled');
    }
  }

  handleSubmit(e) {
    const { submit, form } = this.dom;
    if (submit.hasAttribute('disabled')) return;
    sendValuesToZaiusAndBoxever(
      form.querySelectorAll(
        'input:not([type=hidden]):not([submit]):not([type=submit]), select'
      )
    );
  }

  handleFormClick(e) {
    const event = new window.Event('submit');
    this.dom.form.dispatchEvent(event);
  }

  handleFormChange() {
    const valid = [];
    const { form } = this.dom;
    const requiredFields = form.querySelectorAll('input[required]');
    const emailFields = form.querySelectorAll('input[type="email"]');
    const normalFields = form.querySelectorAll(
      'input:not([type=hidden]):not([required]):not([submit])'
    );

    emailFields.forEach(emailField => {
      const wrapper = emailField.closest('.form__field-wrapper');

      if (wrapper) {
        const error = wrapper.querySelector('.field-validation-error');

        const constraints = {
          from: {
            email: true
          }
        };

        if (!error && !validate({ from: emailField.value }, constraints)) {
          valid.push(true);
        } else {
          valid.push(false);
        }
      }
    });

    requiredFields.forEach(requiredField => {
      const wrapper = requiredField.closest('.form__field-wrapper');

      if (wrapper) {
        const error = wrapper.querySelector('.field-validation-error');
        if (!error && requiredField.value) {
          valid.push(true);
        } else {
          valid.push(false);
        }
      }
    });

    normalFields.forEach(normalField => {
      const wrapper = normalField.closest('.form__field-wrapper');

      if (wrapper) {
        const error = wrapper.querySelector('.field-validation-error');

        if (!error) {
          valid.push(true);
        } else {
          valid.push(false);
        }
      }
    });

    if (
      valid.length &&
      valid.every(bool => bool) &&
      // eslint-disable-next-line no-undefined
      (form.dataset.captcha === undefined || form.dataset.captcha === 'ok')
    ) {
      this.dom.submit.disabled = false;
      this.dom.submitWrapper.classList.remove('form__submit-wrapper--disabled');
    } else {
      this.dom.submit.disabled = true;
      this.dom.submitWrapper.classList.add('form__submit-wrapper--disabled');
    }

    return valid;
  }

  showSpinner(e) {
    if (this.dom.spinner && e.isTrusted) {
      this.dom.spinner.style.display = 'block';
    }

    if (!this.handleFormChange().every(bool => bool)) {
      this.dom.spinner.style.removeProperty('display');
    }

    jQuery(`#${this.dom.form.id}`).valid();
  }

  handleFocus(e) {
    e.srcElement.classList.add('generic-form__input--with-focus');
  }

  handleBlur(e) {
    if (!e.srcElement.value) {
      e.srcElement.classList.remove('generic-form__input--with-focus');
    }
  }

  checkValue() {
    this.dom.formInputs.forEach(element => {
      if (element.value) {
        element.classList.add('generic-form__input--with-focus');
      }
    });
  }
}

export default Module;
